// src/components/common/Header.jsx
// 상단 고정 헤더

import React from 'react';

export default function Header() {
  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: 480,
      height: 'var(--header-h)',
      background: 'var(--primary)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 16px',
      zIndex: 100,
    }}>
      {/* 로고 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 20, fontWeight: 800, color: 'white', letterSpacing: '-0.5px' }}>
          스테이메이트
        </span>
        {/* Beta 뱃지 */}
        <span style={{
          background: 'var(--green)',
          color: 'white',
          fontSize: 10,
          fontWeight: 700,
          padding: '2px 6px',
          borderRadius: 4,
          letterSpacing: '0.05em',
        }}>
          BETA
        </span>
      </div>

      {/* by 와캠핑 */}
      <span style={{
        fontSize: 12,
        color: 'rgba(255,255,255,0.55)',
        fontWeight: 500,
      }}>
        by 와캠핑
      </span>
    </header>
  );
}
